import React, { useState, useEffect } from "react";
import TextFieldValidator from './TextFieldValidator';

const badWords = [
    "nig", "naz", "jew", "fag", "neg", "gay", "g4y", "g@y",
    "n1g", "naz", "j3w", "f@g", "fag", "tit", "t1t",
    "con", "c0n", "dam", "d4m", "h3l",
    "cnt", "f@g", "fuc", "fuk", "fok", "f0k", "f0c", "foc",
    "ass", "a$$", "@ss", "as$", "a$s", "a55", "4ss", "a5s", "45s", "455",
    "cum", "lsd", "kkk", "xxx", "xx", "suk", "suc", "shi", "sh1", "5h", "uck", "5uk",
    "á", "ä", "í", "ï", "ü", "é", "ú", "ë", "ì", "ÿ", "ý",
    "r@p", "rap", "r4p", "dik", "d1c", "dic", "d1k",
    "nog", "ó", "ö", "ò", "peg", "p3g", "kys", "kil",
    "whr", "h03", "ho3", "hoe", "h0e", "slt", "18+", "poo", "p00", "p0o", "po0",
    "𝕒", "𝕓", "𝕔", "𝕕", "𝕖", "𝕗", "𝕘", "𝕙", "𝕚", "𝕛", "𝕜", "𝕝", "𝕞", "𝕟", "𝕠", "𝕡", "𝕣", "𝕤", "𝕥", "𝕦", "𝕧", "𝕨", "𝕩", "𝕪", "𝕫",
    "𝖋", "𝖈", "𝖎", "𝖌", "𝖊", "𝖗", "𝓯", "𝓬", "𝓲", "𝓰", "𝓭", "𝓮", "𝓻", "𝓾", "𝓽", "🄶", "🄵", "🄲", "ⓕ", "ⓒ", "ⓖ",
    "88", "14", "420", "426", "911", "748", "311", "666", "69"
];

const checkForBadLanguage = (input) => {
    const lowerText = input.toLowerCase();
    return badWords.some((word) => lowerText.includes(word));
};

//--------------------start of Random Text
function getRandomLetter() {
    // ASCII code for uppercase 'A' is 65, and 'Z' is 90
    const minCharCode = 65;
    const maxCharCode = 90;
    const randomCharCode = Math.floor(Math.random() * (maxCharCode - minCharCode + 1)) + minCharCode;
    const newRandomLetter = String.fromCharCode(randomCharCode);
    return newRandomLetter;
}
const randomDefaultName = (tries = 0) => {
    if (tries > 50) return { chars: ['U', 'S', 'R'] };

    const chars = [
        getRandomLetter(),
        getRandomLetter(),
        getRandomLetter()
    ];

    const newName = chars.join("").trim();
    ;
    if (checkForBadLanguage(newName))
        return randomDefaultName(tries + 1);
    return { chars };
};
//--------------------end of Random Text

function InputName({ onGetPlayerName, onGetErrorMsg }) {
    const [isRedFlag, setRedFlag] = useState(false);
    const [{ chars }] = useState(() => randomDefaultName());

    const [combinedTexts, setCombinedTexts] =
        useState(() => {
            const initial = {};
            chars.forEach((char, i) => {
                initial[i + 1] = char;
            });
            return initial;
        }, [chars]);

    useEffect(() => {
        const initialName = Object.values(combinedTexts).join("").trim();
        onGetPlayerName(initialName);
    }, [onGetPlayerName, combinedTexts]); // Dependency on onGetPlayerName and combinedTexts

    const combineInputs = (index, value) => {
        const updatedInputs = {
            ...combinedTexts,
            [index]: value,
        };
        setCombinedTexts(updatedInputs);

        const combined = Object.values(updatedInputs).join("").trim();
        if (checkForBadLanguage(combined)) {
            onGetErrorMsg?.(0, 'Please avoid using inappropriate language.');
            setRedFlag(true);
        }
        else if (combined === '') {
            onGetErrorMsg?.(0, 'Please enter something.');
            setRedFlag(true);
        }
        else {
            onGetErrorMsg?.(0, ''); // clear error
            setRedFlag(false);
        }
        console.log("combined Name: ", combined);
        onGetPlayerName?.(combined);
    };

    let letterInTextfields =
        (<div >
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                {chars.map((initialRandChar, i) => (
                    <TextFieldValidator key={i} index={i + 1} initialInput={initialRandChar} onGetErrorMsg={onGetErrorMsg} onGetInput={combineInputs} isRedFlagFromParent={isRedFlag} />
                ))}
            </div>
        </div>)
    return (
        <div>{letterInTextfields}</div>
    );
}
export default InputName;